/* eslint-disable @typescript-eslint/no-explicit-any */

// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace logUtil {
  let isLoggerActive: boolean | undefined;
  const consoleBold = "font-weight: bold";
  const consoleNormal = "font-weight: normal";


  let _logPrefix = "domain-client";
  export const isDebug = (): boolean => {
    if (isLoggerActive != null) return isLoggerActive;
    isLoggerActive = window.location?.search?.indexOf("debug=true") > 0;
    return isLoggerActive;
  }
  export const setLogPrefix = (prefix: string) => {
    _logPrefix = prefix;
    isDebug();
  }
  setLogPrefix(_logPrefix);

  

  // export const consoleLog = (message: any, ...data: any[]) => {
  //   if (logger) {
  //     console?.log(`%c${_logPrefix}%c`, consoleBold, consoleNormal, message, data);
  //   }
  // }
  export const consoleLog = (...data:any) => {
    if (isLoggerActive) {
        console?.log(`%c${_logPrefix}%c`, consoleBold, consoleNormal,...data);
      }   
  }

  export const consoleWarn = (...data: any) => {
    console?.warn(`%c${_logPrefix}%c`, consoleBold, consoleNormal, ...data)
  }

  export const consoleError = (...data: any) => {
    console?.error(`%c${_logPrefix}%c`, consoleBold, consoleNormal, ...data)
  }

  export const throwError = (message: string) => {
    throw new Error(message);

  }
  export const throwEvalError = (message: string) => {
    throw new EvalError(message);

  }

}



